import { render, staticRenderFns } from "./ContactsInfoForPointSettings.vue?vue&type=template&id=72291cc8&functional=true&"
import script from "./ContactsInfoForPointSettings.vue?vue&type=script&lang=js&"
export * from "./ContactsInfoForPointSettings.vue?vue&type=script&lang=js&"
import style0 from "./ContactsInfoForPointSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VExpansionPanel,VExpansionPanelContent,VFlex,VLayout,VTextarea})
